var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{class:_vm.fixed ? 'backButton' : '',attrs:{"icon":"el-icon-arrow-left","size":"small","current":_vm.current,"superior":_vm.superior,"add":_vm.add},on:{"click":_vm.backToList}},[_vm._v("\n    Back\n")])}
var staticRenderFns = []

export { render, staticRenderFns }